import PropTypes from "prop-types";
import clsx from "clsx";

// Components
import DoubleCheckingButton from "@Layouts/components/Buttons/DoubleCheckingButton";

// MUI
import { IconButton, Grid, Skeleton, SvgIcon, Typography } from "@mui/material";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { ReactComponent as TrashIcon } from "@/assets/icons/actions/trash.svg";

const CollapsibleSection = (props) => {
	const { collapsed, loading, handleExpandToggle } = props;

	return (
		<>
			{loading ? (
				<Skeleton variant="circular" width={35} height={35} sx={{ marginLeft: "10px" }} />
			) : (
				<IconButton size="small" aria-label="expand" className="section-container-expand-btn" onClick={handleExpandToggle}>
					<ArrowForwardIosRoundedIcon className={collapsed ? "arrow-icon-point-down" : "arrow-icon-point-up"} />
				</IconButton>
			)}
		</>
	);
};
CollapsibleSection.propTypes = {
	collapsed: PropTypes.bool,
	loading: PropTypes.bool,
	handleExpandToggle: PropTypes.func,
};

const DeletableSection = (props) => {
	const { title, icon, iconHover, loading, readOnly, onDeleteAction } = props;

	return (
		<>
			{loading ? (
				<Skeleton variant="circular" width={35} height={35} />
			) : (
				<DoubleCheckingButton
					title={title || "Remove Section"}
					icon={
						icon || (
							<CloseRoundedIcon
								className={clsx({
									"!text-disabled": readOnly,
								})}
							/>
						)
					}
					iconHover={iconHover || <CloseRoundedIcon />}
					endIcon={<SvgIcon className="!text-[16px] ml-[4px]" component={TrashIcon} viewBox={"0 0 14 14"} />}
					mainButtonClasses={"btn-simple-remove"}
					confirmationSx={{ right: "0px !important", width: "140px !important" }}
					onDeleteAction={onDeleteAction}
					disabled={readOnly}
				/>
			)}
		</>
	);
};
DeletableSection.propTypes = {
	title: PropTypes.string,
	icon: PropTypes.node,
	iconHover: PropTypes.node,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onDeleteAction: PropTypes.func,
};

const TitleSection = (props) => {
	const { title, sx, loading, leftAlignment } = props;
	const xs = leftAlignment ? 0 : 12;
	const padding = leftAlignment ? "0 !important" : "16px";
	const titleClass= leftAlignment ? "section-title" : "page-title";
	return (
		<Grid item xs={xs} sx={{paddingTop: padding}}>
			{loading ? (
				<Skeleton variant="rectangular" width={400} height={25} sx={{ borderRadius: "6px" }} />
			) : (
				<Typography className={titleClass} component="div" sx={sx} style={{ lineHeight: 1.1 }}>
					{title}
				</Typography>
			)}
		</Grid>
	);
};
TitleSection.propTypes = {
	title: PropTypes.string,
	sx: PropTypes.object,
	loading: PropTypes.bool,
	leftAlignment: PropTypes.bool,
};

export { CollapsibleSection, DeletableSection, TitleSection };
